import { Paths, PathValue } from "@mctypes/global.types";
import React from "react";
import { McDropdownLegacy, McInputNew, McTextAreaNew } from "../../../../../../../components";
import { Radio, Paper, Stack, Title } from "@mantine/core";
import {
  FUNKSJONSKONTROLL_ISOLATOR_TESTER_METODER,
  FunksjonskontrollIsolatorTesterEnum,
} from "@mcapps/shared/gkReportConstants";
import { IGKFunksjonskontrollIsolatorResultater, IGKRapport } from "@mcapps/shared/reportSchemas/gkReportSchema";
const FunksjonskontrollIsolator: React.FC<{
  onUpdateEditData: <P extends Paths<IGKRapport, 4>>(path: P, value: PathValue<IGKRapport, P>) => void;
  data: IGKFunksjonskontrollIsolatorResultater;
}> = ({ data, onUpdateEditData }) => {
  const addOrRemoveTest = (test: FunksjonskontrollIsolatorTesterEnum) => {
    data.inndata.valgtMetode[test] = !data.inndata.valgtMetode[test];
    onUpdateEditData("testResultater.funksjonskontrollIsolator.inndata.valgtMetode", data.inndata.valgtMetode);
  };
  return (
    <Paper withBorder p="sm" radius="sm" bg="#fdfdff">
      <Stack gap="xs">
        <Title order={4} fw={400}>
          Funkjonskontroll av isolator
        </Title>
        <b>Velg hvilke tester som skal utføres?</b>
        <div style={{ marginBottom: "1.5rem", width: "25%" }}>
          <McDropdownLegacy
            filterOptions={FUNKSJONSKONTROLL_ISOLATOR_TESTER_METODER.map((test) => {
              return {
                ...test,
                isActive: data.inndata.valgtMetode[test.value],
              };
            })}
            onClick={(value) => addOrRemoveTest(value)}
            title="Velg tester"
            color="secondary"
            textColor="text-black"
          />
        </div>
        {data.inndata.valgtMetode[FunksjonskontrollIsolatorTesterEnum.LYSPAERERFRONTPANEL] === true && (
          <>
            <h4>Lyspærer, frontpanel</h4>
            <div>
              <Stack gap={0}>
                <Radio
                  checked={data.inndata.lyspaererFrontpanelResultater.godkjent === true}
                  onChange={() =>
                    onUpdateEditData(
                      "testResultater.funksjonskontrollIsolator.inndata.lyspaererFrontpanelResultater.godkjent",
                      true,
                    )
                  }
                  label="Godkjent"
                />
                <Radio
                  checked={data.inndata.lyspaererFrontpanelResultater.godkjent === false}
                  onChange={() =>
                    onUpdateEditData(
                      "testResultater.funksjonskontrollIsolator.inndata.lyspaererFrontpanelResultater.godkjent",
                      false,
                    )
                  }
                  label="Ikke godkjent"
                />
              </Stack>
            </div>
            <div style={{ marginTop: "0.5rem", marginBottom: "1.5rem", width: "50%" }}>
              <McTextAreaNew
                label="Kommentar:"
                value={data.inndata.lyspaererFrontpanelResultater.kommentar}
                onChange={(e) =>
                  onUpdateEditData(
                    "testResultater.funksjonskontrollIsolator.inndata.lyspaererFrontpanelResultater.kommentar",
                    e.target.value,
                  )
                }
              />
            </div>
          </>
        )}
        {data.inndata.valgtMetode[FunksjonskontrollIsolatorTesterEnum.LYSPAERERINTERLOCK] === true && (
          <>
            <h4>Lyspærer, interlock i slusene</h4>
            <div>
              <Stack gap={0}>
                <Radio
                  checked={data.inndata.lyspaererInterlockResultater.godkjent === true}
                  onChange={() =>
                    onUpdateEditData(
                      "testResultater.funksjonskontrollIsolator.inndata.lyspaererInterlockResultater.godkjent",
                      true,
                    )
                  }
                  label="Godkjent"
                />
                <Radio
                  checked={data.inndata.lyspaererInterlockResultater.godkjent === false}
                  onChange={() =>
                    onUpdateEditData(
                      "testResultater.funksjonskontrollIsolator.inndata.lyspaererInterlockResultater.godkjent",
                      false,
                    )
                  }
                  label="Ikke godkjent"
                />
              </Stack>
            </div>
            <div style={{ marginTop: "0.5rem", marginBottom: "1.5rem", width: "50%" }}>
              <McTextAreaNew
                label="Kommentar:"
                value={data.inndata.lyspaererInterlockResultater.kommentar}
                onChange={(e) =>
                  onUpdateEditData(
                    "testResultater.funksjonskontrollIsolator.inndata.lyspaererInterlockResultater.kommentar",
                    e.target.value,
                  )
                }
              />
            </div>
          </>
        )}
        {data.inndata.valgtMetode[FunksjonskontrollIsolatorTesterEnum.INTERNVIFTER] === true && (
          <>
            <h4>Internvifter, kontroll av spenning</h4>
            <Stack gap={0} mb={8}>
              <McInputNew
                label="Fyll inn måleresultat (V):"
                value={data.inndata.internvifterResultater.maaleresultat}
                onBlur={(e) =>
                  onUpdateEditData(
                    "testResultater.funksjonskontrollIsolator.inndata.internvifterResultater.maaleresultat",
                    Number(e.target.value),
                  )
                }
                normalizeNumbers={true}
                type="text"
                style={{ width: "25%" }}
              />
            </Stack>
            <div>
              <Stack gap={0}>
                <Radio
                  checked={data.inndata.internvifterResultater.godkjent === true}
                  onChange={() =>
                    onUpdateEditData(
                      "testResultater.funksjonskontrollIsolator.inndata.internvifterResultater.godkjent",
                      true,
                    )
                  }
                  label="Godkjent"
                />
                <Radio
                  checked={data.inndata.internvifterResultater.godkjent === false}
                  onChange={() =>
                    onUpdateEditData(
                      "testResultater.funksjonskontrollIsolator.inndata.internvifterResultater.godkjent",
                      false,
                    )
                  }
                  label="Ikke godkjent"
                />
              </Stack>
            </div>
            <div style={{ marginTop: "0.5rem", marginBottom: "1.5rem", width: "50%" }}>
              <McTextAreaNew
                label="Kommentar:"
                value={data.inndata.internvifterResultater.kommentar}
                onChange={(e) =>
                  onUpdateEditData(
                    "testResultater.funksjonskontrollIsolator.inndata.internvifterResultater.kommentar",
                    e.target.value,
                  )
                }
              />
            </div>
          </>
        )}
        {data.inndata.valgtMetode[FunksjonskontrollIsolatorTesterEnum.EKSTERNVIFTE] === true && (
          <>
            <h4>Ekternvifte, kontroll av spenning</h4>
            <Stack gap={0} mb={8}>
              <McInputNew
                label="Fyll inn måleresultat (V):"
                value={data.inndata.eksternvifteResultater.maaleresultat}
                onBlur={(e) =>
                  onUpdateEditData(
                    "testResultater.funksjonskontrollIsolator.inndata.eksternvifteResultater.maaleresultat",
                    Number(e.target.value),
                  )
                }
                normalizeNumbers={true}
                type="text"
                style={{ width: "25%" }}
              />
            </Stack>
            <div>
              <Stack gap={0}>
                <Radio
                  checked={data.inndata.eksternvifteResultater.godkjent === true}
                  onChange={() =>
                    onUpdateEditData(
                      "testResultater.funksjonskontrollIsolator.inndata.eksternvifteResultater.godkjent",
                      true,
                    )
                  }
                  label="Godkjent"
                />
                <Radio
                  checked={data.inndata.eksternvifteResultater.godkjent === false}
                  onChange={() =>
                    onUpdateEditData(
                      "testResultater.funksjonskontrollIsolator.inndata.eksternvifteResultater.godkjent",
                      false,
                    )
                  }
                  label="Ikke godkjent"
                />
              </Stack>
            </div>
            <div style={{ marginTop: "0.5rem", marginBottom: "1.5rem", width: "50%" }}>
              <McTextAreaNew
                label="Kommentar:"
                value={data.inndata.eksternvifteResultater.kommentar}
                onChange={(e) =>
                  onUpdateEditData(
                    "testResultater.funksjonskontrollIsolator.inndata.eksternvifteResultater.kommentar",
                    e.target.value,
                  )
                }
              />
            </div>
          </>
        )}
        {data.inndata.valgtMetode[FunksjonskontrollIsolatorTesterEnum.TILBAKESLAGSVENTIL] === true && (
          <>
            <h4>Tilbakeslagsventil</h4>
            <div>
              <Stack gap={0}>
                <Radio
                  checked={data.inndata.tilbakeslagsventilResultater.godkjent === true}
                  onChange={() =>
                    onUpdateEditData(
                      "testResultater.funksjonskontrollIsolator.inndata.tilbakeslagsventilResultater.godkjent",
                      true,
                    )
                  }
                  label="Godkjent"
                />
                <Radio
                  checked={data.inndata.tilbakeslagsventilResultater.godkjent === false}
                  onChange={() =>
                    onUpdateEditData(
                      "testResultater.funksjonskontrollIsolator.inndata.tilbakeslagsventilResultater.godkjent",
                      false,
                    )
                  }
                  label="Ikke godkjent"
                />
              </Stack>
            </div>
            <div style={{ marginTop: "0.5rem", marginBottom: "1.5rem", width: "50%" }}>
              <McTextAreaNew
                label="Kommentar:"
                value={data.inndata.tilbakeslagsventilResultater.kommentar}
                onChange={(e) =>
                  onUpdateEditData(
                    "testResultater.funksjonskontrollIsolator.inndata.tilbakeslagsventilResultater.kommentar",
                    e.target.value,
                  )
                }
              />
            </div>
          </>
        )}
        {data.inndata.valgtMetode[FunksjonskontrollIsolatorTesterEnum.ALARMFORINTERNTRYKK] === true && (
          <>
            <h4>Alarm for interntrykk</h4>
            <div>
              <Stack gap={0}>
                <Radio
                  checked={data.inndata.alarmForInterntrykkResultater.godkjent === true}
                  onChange={() =>
                    onUpdateEditData(
                      "testResultater.funksjonskontrollIsolator.inndata.alarmForInterntrykkResultater.godkjent",
                      true,
                    )
                  }
                  label="Godkjent"
                />
                <Radio
                  checked={data.inndata.alarmForInterntrykkResultater.godkjent === false}
                  onChange={() =>
                    onUpdateEditData(
                      "testResultater.funksjonskontrollIsolator.inndata.alarmForInterntrykkResultater.godkjent",
                      false,
                    )
                  }
                  label="Ikke godkjent"
                />
              </Stack>
            </div>
            <div style={{ marginTop: "0.5rem", marginBottom: "1.5rem", width: "50%" }}>
              <McTextAreaNew
                label="Kommentar:"
                value={data.inndata.alarmForInterntrykkResultater.kommentar}
                onChange={(e) =>
                  onUpdateEditData(
                    "testResultater.funksjonskontrollIsolator.inndata.alarmForInterntrykkResultater.kommentar",
                    e.target.value,
                  )
                }
              />
            </div>
          </>
        )}
        {data.inndata.valgtMetode[FunksjonskontrollIsolatorTesterEnum.ALARMFORLUFTVEKSLINGER] === true && (
          <>
            <h4>Alarm for luftvekslinger</h4>
            <div>
              <Stack gap={0}>
                <Radio
                  checked={data.inndata.alarmForLuftvekslingerResultater.godkjent === true}
                  onChange={() =>
                    onUpdateEditData(
                      "testResultater.funksjonskontrollIsolator.inndata.alarmForLuftvekslingerResultater.godkjent",
                      true,
                    )
                  }
                  label="Godkjent"
                />
                <Radio
                  checked={data.inndata.alarmForLuftvekslingerResultater.godkjent === false}
                  onChange={() =>
                    onUpdateEditData(
                      "testResultater.funksjonskontrollIsolator.inndata.alarmForLuftvekslingerResultater.godkjent",
                      false,
                    )
                  }
                  label="Ikke godkjent"
                />
              </Stack>
            </div>
            <div style={{ marginTop: "0.5rem", marginBottom: "1.5rem", width: "50%" }}>
              <McTextAreaNew
                label="Kommentar:"
                value={data.inndata.alarmForLuftvekslingerResultater.kommentar}
                onChange={(e) =>
                  onUpdateEditData(
                    "testResultater.funksjonskontrollIsolator.inndata.alarmForLuftvekslingerResultater.kommentar",
                    e.target.value,
                  )
                }
              />
            </div>
          </>
        )}
        {data.inndata.valgtMetode[FunksjonskontrollIsolatorTesterEnum.SKIFTEFORFILTERISLUSE] === true && (
          <>
            <h4>Skifte forfilter i sluse</h4>
            <div>
              <Stack gap={0}>
                <Radio
                  checked={data.inndata.skifteForfilterISluseResultater.godkjent === true}
                  onChange={() =>
                    onUpdateEditData(
                      "testResultater.funksjonskontrollIsolator.inndata.skifteForfilterISluseResultater.godkjent",
                      true,
                    )
                  }
                  label="Godkjent"
                />
                <Radio
                  checked={data.inndata.skifteForfilterISluseResultater.godkjent === false}
                  onChange={() =>
                    onUpdateEditData(
                      "testResultater.funksjonskontrollIsolator.inndata.skifteForfilterISluseResultater.godkjent",
                      false,
                    )
                  }
                  label="Ikke godkjent"
                />
              </Stack>
            </div>
            {data.inndata.skifteForfilterISluseResultater.godkjent === false && (
              <div style={{ marginTop: "0.5rem" }}>
                <b>Er filteret skiftet? &#40;-&#41;:</b>
                <Stack gap={0}>
                  <Radio
                    checked={data.inndata.skifteForfilterISluseResultater.filterSkiftet === true}
                    onChange={() =>
                      onUpdateEditData(
                        "testResultater.funksjonskontrollIsolator.inndata.skifteForfilterISluseResultater.filterSkiftet",
                        true,
                      )
                    }
                    label="Filteret er skiftet"
                  />
                  <Radio
                    checked={data.inndata.skifteForfilterISluseResultater.filterSkiftet === false}
                    onChange={() =>
                      onUpdateEditData(
                        "testResultater.funksjonskontrollIsolator.inndata.skifteForfilterISluseResultater.filterSkiftet",
                        false,
                      )
                    }
                    label="Filteret er IKKE skiftet"
                  />
                </Stack>
              </div>
            )}
            <div style={{ marginTop: "0.5rem", marginBottom: "1.5rem", width: "50%" }}>
              <McTextAreaNew
                label="Kommentar:"
                value={data.inndata.skifteForfilterISluseResultater.kommentar}
                onChange={(e) =>
                  onUpdateEditData(
                    "testResultater.funksjonskontrollIsolator.inndata.skifteForfilterISluseResultater.kommentar",
                    e.target.value,
                  )
                }
              />
            </div>
          </>
        )}
        {data.inndata.valgtMetode[FunksjonskontrollIsolatorTesterEnum.SKIFTEPAKNINGERSLUSERUTVENDIG] === true && (
          <>
            <h4>Skifte pakninger i sluses utvendig</h4>
            <div>
              <Stack gap={0}>
                <Radio
                  checked={data.inndata.skiftePakningerSluserUtvendigResultater.godkjent === true}
                  onChange={() =>
                    onUpdateEditData(
                      "testResultater.funksjonskontrollIsolator.inndata.skiftePakningerSluserUtvendigResultater.godkjent",
                      true,
                    )
                  }
                  label="Godkjent"
                />
                <Radio
                  checked={data.inndata.skiftePakningerSluserUtvendigResultater.godkjent === false}
                  onChange={() =>
                    onUpdateEditData(
                      "testResultater.funksjonskontrollIsolator.inndata.skiftePakningerSluserUtvendigResultater.godkjent",
                      false,
                    )
                  }
                  label="Ikke godkjent"
                />
              </Stack>
            </div>
            {data.inndata.skiftePakningerSluserUtvendigResultater.godkjent === false && (
              <div style={{ marginTop: "0.5rem" }}>
                <b>Er pakninger skiftet? &#40;-&#41;:</b>
                <Stack gap={0}>
                  <Radio
                    checked={data.inndata.skiftePakningerSluserUtvendigResultater.pakningerSkiftet === true}
                    onChange={() =>
                      onUpdateEditData(
                        "testResultater.funksjonskontrollIsolator.inndata.skiftePakningerSluserUtvendigResultater.pakningerSkiftet",
                        true,
                      )
                    }
                    label="Pakninger er skiftet"
                  />
                  <Radio
                    checked={data.inndata.skiftePakningerSluserUtvendigResultater.pakningerSkiftet === false}
                    onChange={() =>
                      onUpdateEditData(
                        "testResultater.funksjonskontrollIsolator.inndata.skiftePakningerSluserUtvendigResultater.pakningerSkiftet",
                        false,
                      )
                    }
                    label="Pakninger er IKKE skiftet"
                  />
                </Stack>
              </div>
            )}
            <div style={{ marginTop: "0.5rem", marginBottom: "1.5rem", width: "50%" }}>
              <McTextAreaNew
                label="Kommentar:"
                value={data.inndata.skiftePakningerSluserUtvendigResultater.kommentar}
                onChange={(e) =>
                  onUpdateEditData(
                    "testResultater.funksjonskontrollIsolator.inndata.skiftePakningerSluserUtvendigResultater.kommentar",
                    e.target.value,
                  )
                }
              />
            </div>
          </>
        )}
        {data.inndata.valgtMetode[FunksjonskontrollIsolatorTesterEnum.ETTERSTRAMMEUTSATTEKOMPONENTER] === true && (
          <>
            <h4>Etterstramme utsatte komponenter</h4>
            <div>
              <Stack gap={0}>
                <Radio
                  checked={data.inndata.etterstrammeUtsatteKomponenterResultater.godkjent === true}
                  onChange={() =>
                    onUpdateEditData(
                      "testResultater.funksjonskontrollIsolator.inndata.etterstrammeUtsatteKomponenterResultater.godkjent",
                      true,
                    )
                  }
                  label="Godkjent"
                />
                <Radio
                  checked={data.inndata.etterstrammeUtsatteKomponenterResultater.godkjent === false}
                  onChange={() =>
                    onUpdateEditData(
                      "testResultater.funksjonskontrollIsolator.inndata.etterstrammeUtsatteKomponenterResultater.godkjent",
                      false,
                    )
                  }
                  label="Ikke godkjent"
                />
              </Stack>
            </div>
            <div style={{ marginTop: "0.5rem", marginBottom: "1.5rem", width: "50%" }}>
              <McTextAreaNew
                label="Kommentar:"
                value={data.inndata.etterstrammeUtsatteKomponenterResultater.kommentar}
                onChange={(e) =>
                  onUpdateEditData(
                    "testResultater.funksjonskontrollIsolator.inndata.etterstrammeUtsatteKomponenterResultater.kommentar",
                    e.target.value,
                  )
                }
              />
            </div>
          </>
        )}
        {data.inndata.valgtMetode[FunksjonskontrollIsolatorTesterEnum.SMOERESYLINDER] === true && (
          <>
            <h4>Smøre sylinder/dørskinner</h4>
            <div>
              <Stack gap={0}>
                <Radio
                  checked={data.inndata.smoereSylinderResultater.godkjent === true}
                  onChange={() =>
                    onUpdateEditData(
                      "testResultater.funksjonskontrollIsolator.inndata.smoereSylinderResultater.godkjent",
                      true,
                    )
                  }
                  label="Godkjent"
                />
                <Radio
                  checked={data.inndata.smoereSylinderResultater.godkjent === false}
                  onChange={() =>
                    onUpdateEditData(
                      "testResultater.funksjonskontrollIsolator.inndata.smoereSylinderResultater.godkjent",
                      false,
                    )
                  }
                  label="Ikke godkjent"
                />
              </Stack>
            </div>
            <div style={{ marginTop: "0.5rem", marginBottom: "1.5rem", width: "50%" }}>
              <McTextAreaNew
                label="Kommentar:"
                value={data.inndata.smoereSylinderResultater.kommentar}
                onChange={(e) =>
                  onUpdateEditData(
                    "testResultater.funksjonskontrollIsolator.inndata.smoereSylinderResultater.kommentar",
                    e.target.value,
                  )
                }
              />
            </div>
          </>
        )}
        {data.inndata.valgtMetode[FunksjonskontrollIsolatorTesterEnum.PUSSEMAGNETER] === true && (
          <>
            <h4>Pusse opp magneter ved dårlig kontakt</h4>
            <div>
              <Stack gap={0}>
                <Radio
                  checked={data.inndata.pusseMagneterResultater.godkjent === true}
                  onChange={() =>
                    onUpdateEditData(
                      "testResultater.funksjonskontrollIsolator.inndata.pusseMagneterResultater.godkjent",
                      true,
                    )
                  }
                  label="Godkjent"
                />
                <Radio
                  checked={data.inndata.pusseMagneterResultater.godkjent === false}
                  onChange={() =>
                    onUpdateEditData(
                      "testResultater.funksjonskontrollIsolator.inndata.pusseMagneterResultater.godkjent",
                      false,
                    )
                  }
                  label="Ikke godkjent"
                />
              </Stack>
            </div>
            {data.inndata.pusseMagneterResultater.godkjent === false && (
              <div style={{ marginTop: "0.5rem" }}>
                <b>Er magneter pusset? &#40;-&#41;:</b>
                <Stack gap={0}>
                  <Radio
                    checked={data.inndata.pusseMagneterResultater.magneterPusset === true}
                    onChange={() =>
                      onUpdateEditData(
                        "testResultater.funksjonskontrollIsolator.inndata.pusseMagneterResultater.magneterPusset",
                        true,
                      )
                    }
                    label="Magneter er pusset"
                  />
                  <Radio
                    checked={data.inndata.pusseMagneterResultater.magneterPusset === false}
                    onChange={() =>
                      onUpdateEditData(
                        "testResultater.funksjonskontrollIsolator.inndata.pusseMagneterResultater.magneterPusset",
                        false,
                      )
                    }
                    label="Magneter er IKKE skiftet"
                  />
                </Stack>
              </div>
            )}
            <div style={{ marginTop: "0.5rem", marginBottom: "1.5rem", width: "50%" }}>
              <McTextAreaNew
                label="Kommentar:"
                value={data.inndata.pusseMagneterResultater.kommentar}
                onChange={(e) =>
                  onUpdateEditData(
                    "testResultater.funksjonskontrollIsolator.inndata.pusseMagneterResultater.kommentar",
                    e.target.value,
                  )
                }
              />
            </div>
          </>
        )}
        {data.inndata.valgtMetode[FunksjonskontrollIsolatorTesterEnum.DEKONTAMINERINGSARRANGEMENT] === true && (
          <>
            <h4>Dekontamineringsarragement</h4>
            <div>
              <Stack gap={0}>
                <Radio
                  checked={data.inndata.dekontamineringsarrangement.godkjent === true}
                  onChange={() =>
                    onUpdateEditData(
                      "testResultater.funksjonskontrollIsolator.inndata.dekontamineringsarrangement.godkjent",
                      true,
                    )
                  }
                  label="Godkjent"
                />
                <Radio
                  checked={data.inndata.dekontamineringsarrangement.godkjent === false}
                  onChange={() =>
                    onUpdateEditData(
                      "testResultater.funksjonskontrollIsolator.inndata.dekontamineringsarrangement.godkjent",
                      false,
                    )
                  }
                  label="Ikke godkjent"
                />
              </Stack>
            </div>
            <div style={{ marginTop: "0.5rem", marginBottom: "1.5rem", width: "50%" }}>
              <McTextAreaNew
                label="Kommentar:"
                value={data.inndata.dekontamineringsarrangement.kommentar}
                onChange={(e) =>
                  onUpdateEditData(
                    "testResultater.funksjonskontrollIsolator.inndata.dekontamineringsarrangement.kommentar",
                    e.target.value,
                  )
                }
              />
            </div>
          </>
        )}
      </Stack>
    </Paper>
  );
};
export default FunksjonskontrollIsolator;
